
<app-breadcrumb current="Modelo" [(links)]="links"></app-breadcrumb>
<div class="backgroundColor backgroundColor star-dust darken-3">
  <section class="container-fluid backgroundColor star-dust darken-3 position-relative top-119" id="my-element">
    <div class="container">
      <!--<div class="d-flex justify-content-end">
        <a href="/produtos?marca={{produto.marcasId}}&query=&tipo=">
          <button class="btn btn-grad mt-24">Retroceder</button>
        </a>
      </div>-->
      <div class="row pt-24">
        <div class="col-12 col-md-12 col-lg-6">          
          <div class="col-12 col-md-6 col-lg-11 col-xl-10 mx-auto pb-24">
            <div class="card model-border" id="padding-right">
              <img src="https://{{apiUrl}}/api/produtos/image/{{produto.id}}/{{master}}" class="img-fluid my-5" alt="...">
              <div class="card-body mb-3 d-flex justify-content-center">
                <div class="row col-12 col-lg-12 padd-none">
                  <ng-container *ngFor="let row of media; let i = index">
                    <div class="d-flex">
                      <div class="col-3 col-md-3 col-lg-3 padd-none" *ngFor="let col of row; let j = index">
                        <img src="https://{{apiUrl}}/api/produtos/image/{{produto.id}}/{{col}}" class="img-thumbnail img-expand pointer" alt="..." (click)="swapImage(i,j)">
                      </div>
                    </div>
                    <hr class="backgroundColor amber base w-100" *ngIf="i != 0">
                  </ng-container>
                </div>
              </div>
            </div>
          </div>
        </div>
        <div class="col-12 col-md-12 col-lg-5 col-xl-6">         
          <div class="col-12  backgroundColor light-mine-shaft base py-3 model-border">
            <h1 class="textColor harvest-gold base font-italic">{{marca.nome}}</h1>
            <h2 class="text-white font-italic">{{produto.nome}}</h2>
            <h3 class="text-white font-italic">Ref. {{produto.ref}}</h3>
            <hr class="backgroundColor amber base">
            <h3 class="text-white font-italic">Preço: sob consulta</h3>
            <hr class="backgroundColor amber base">
          </div>
          <div id="accordion" class="myaccordion model-border">
            <div class="card">
              <div class="card-header desc-border-bottom" id="headingOne">
                <h2 class="mb-0">
                  <button type="button" class="d-flex align-items-center justify-content-between btn btn-link" data-toggle="collapse" data-target="#collapseOne" aria-expanded="false" aria-controls="collapseOne" (click)="changePM()">
                    <span class="h2 text-white font-italic">Descrição</span>
                    <span class="fa-stack fa-sm" *ngIf="!pm_ctrl" data-toggle="collapse" data-target="#collapseOne" aria-expanded="false" aria-controls="collapseOne">
                      <fa-icon [icon]="faCircle" class="fas fa-circle fa-stack-2x"></fa-icon>
                      <fa-icon [icon]="faPlus" class="fas fa-plus fa-stack-1x fa-inverse"></fa-icon>
                    </span>
                    <span class="fa-stack fa-sm" *ngIf="pm_ctrl" data-toggle="collapse" data-target="#collapseOne" aria-expanded="false" aria-controls="collapseOne">
                      <fa-icon [icon]="faCircle" class="fas fa-circle fa-stack-2x"></fa-icon>
                      <fa-icon [icon]="faMinus" class="fas fa-plus fa-stack-1x fa-inverse"></fa-icon>
                    </span>
                  </button>
                </h2>
              </div>
              <div id="collapseOne" class="collapse" aria-labelledby="headingOne" data-parent="#accordion">
                <div class="card-body">
                  <p class="card-text text-white">{{produto.desc}}</p>
                </div>
              </div>
            </div>
            <div class="card">
              <div class="card-header" id="headingTwo">
                <h2 class="mb-0">
                  <button class="d-flex align-items-center justify-content-between btn btn-link collapsed" data-toggle="collapse" data-target="#collapseTwo" aria-expanded="false" aria-controls="collapseTwo" (click)="changePM2()">
                    <span class="h2 text-white font-italic">Características</span>
                    <span class="fa-stack fa-sm" *ngIf="!pm2_ctrl" data-toggle="collapse" data-target="#collapseTwo" aria-expanded="false" aria-controls="collapseTwo">
                      <fa-icon [icon]="faCircle" class="fas fa-circle fa-stack-2x"></fa-icon>
                      <fa-icon [icon]="faPlus" class="fas fa-plus fa-stack-1x fa-inverse"></fa-icon>
                    </span>
                    <span class="fa-stack fa-sm" *ngIf="pm2_ctrl" data-toggle="collapse" data-target="#collapseTwo" aria-expanded="false" aria-controls="collapseTwo">
                      <fa-icon [icon]="faCircle" class="fas fa-circle fa-stack-2x"></fa-icon>
                      <fa-icon [icon]="faMinus" class="fas fa-plus fa-stack-1x fa-inverse"></fa-icon>
                    </span>
                  </button>
                </h2>
              </div>
              <div id="collapseTwo" class="collapse" *ngIf="pm2_ctrl">
                <div class="card-body">
                  <ul class="list-group list-group-flush">
                    <li class="list-group-item border-bottom icon text-white" *ngFor="let item of caracteristicas">
                      {{item}}
                    </li>
                  </ul>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </section>
</div>